/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { ModuleLayoutConfig } from '@coursera-web/cds-labs';
import { PromoBarModule } from '@coursera-web/cds-labs';

export type HubPromoBarProps = {
  headline?: string;
  // Markdown; a link such as `[Register here](https://...)` renders inline after the headline.
  description?: string;
};

type PromoBarModuleProps = React.ComponentProps<typeof PromoBarModule> & Pick<ModuleLayoutConfig, 'backgroundColor'>;

const styles = {
  promoBarContainer: css`
    overflow: hidden;
  `,
};

const HubPromoBar = ({ headline, description }: HubPromoBarProps) => {
  const [isDismissed, setIsDismissed] = React.useState(false);

  if (!headline && !description) {
    return null;
  }

  // The same color on the section and the bar makes the bar look full width, without rounded corners.
  const promoBarProps: PromoBarModuleProps = {
    headline: headline ?? '',
    description: description ?? '',
    textLayout: 'single-line',
    bannerColor: 'blue',
    backgroundColor: 'blue',
    centerContent: true,
    hideBackgroundImages: true,
    isDismissed,
    onDismiss: () => setIsDismissed(true),
  };

  return (
    <div css={styles.promoBarContainer}>
      <PromoBarModule {...promoBarProps} />
    </div>
  );
};

export default HubPromoBar;
